import { Grid, Spinner } from '@prometheus/components';
import { ErrorPage } from '@prometheus/features';
import { useEntityNew, useList } from '@prometheus/hooks';
import { Status } from '@prometheus/types';
import React, { FC, useEffect } from 'react';
import { ExecutionSettingsForm } from './ExecutionSettingsForm';
import { ExecutionSettingsDTO } from '@/types';
import {
  getAwsInstanceSizesList,
  getExecutionSettings,
  updateExecutionSettings,
} from '@/api/admin';
import { setBreadcrumbs } from '@prometheus/redux';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

export interface EEConfigurationProps {
  root: any;
}
export const EEConfiguration: FC<EEConfigurationProps> = ({ root }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { entity, status, error, getEntity, updateEntity } =
    useEntityNew<ExecutionSettingsDTO>({
      get: getExecutionSettings,
      update: updateExecutionSettings,
    });

  const { data: awsInstanceSizes, getEntityList } = useList({
    methods: {
      read: { method: getAwsInstanceSizesList },
    },
    primaryKey: 'key',
  });

  useEffect(() => {
    getEntityList();
  }, []);

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          name: t('breadcrumbs.admin'),
          path: `${root.rootPath}`,
        },
        {
          name: t('breadcrumbs.proxy'),
          path: `${root.rootPath}/ee-config`,
        },
      ])
    );
  }, []);

  return (
    <Grid container flexDirection="column" minHeight="calc(100vh - 50px)">
      <Grid container flexGrow={1}>
        <Grid item xs={12} px={6} py={3}>
          {status === Status.IN_PROGRESS ||
          status === Status.IN_PROGRESS_RELOAD ||
          status === Status.INITIAL ? (
            <Spinner color="secondary" />
          ) : status === Status.ERROR ? (
            <ErrorPage {...error?.response} noAction />
          ) : (
            <ExecutionSettingsForm
              settings={entity}
              awsInstanceSizes={Object.values(awsInstanceSizes.byId)}
              update={updateEntity}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
